import React, { useEffect, useRef, useState } from "react";
import Header from "../../../components/global/Header";
import LeftNavbar from "../../../components/global/LeftNavbar";
import {  useTranslation } from 'react-i18next';

export default function MarketoIntegrationSetting() {
    const scrollRef = useRef(null);
    const { t } = useTranslation();
    const translate = t;
    const showModel = () => {
      document.body.classList.add("modal-open");
    };
    const hideModel = () => {
      document.body.classList.remove("modal-open");
    };
    
  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef} tabIndex={0}>
          <div id="content" className="dashboard-wrap">
            <nav className="breadcrumb" aria-label="breadcrumb">
              <ol>
                <li className="breadcrumb-item active" aria-current="page">
                  {translate("home")}
                </li>
              </ol>
            </nav>
             <div className="project-setting-page">
                <div className="project-heading userprofile-heading">
                    <div className="back-arrow flex-center">
                     <button aria-label="back">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none">
                        <path d="M0.46967 5.96967C0.176777 6.26256 0.176777 6.73744 0.46967 7.03033L5.24264 11.8033C5.53553 12.0962 6.01041 12.0962 6.3033 11.8033C6.59619 11.5104 6.59619 11.0355 6.3033 10.7426L2.06066 6.5L6.3033 2.25736C6.59619 1.96447 6.59619 1.48959 6.3033 1.1967C6.01041 0.903806 5.53553 0.903806 5.24264 1.1967L0.46967 5.96967ZM1 7.25H14V5.75H1V7.25Z" fill="#1D4ED8"/>
                        </svg>
                     </button>
                     <span>Back to Settings</span>
                    </div>
                    <h3 className="flex">Marketo Integration</h3>
                    <span>Browse, manage and send your Marketo multilingual emails and landing pages to translation.</span>
                 </div>
                <div className="white-bg"> 
                <div className="integration-tab-content marketo-integration-accordion">
                    <div className="integration-accordion-list open">
                      <div className="accordion-heading flex">
                        <div className="left">
                          <strong>Permission to Use the Marketo Integration</strong>
                        </div>
                        <div className="right">
                           <svg className="plus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                             <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"/>
                             <rect x="12.2773" y="6.5" width="1.44444" height="13" rx="0.722222" fill="#1D4ED8"/>
                             <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"/>
                            </svg>
                            <svg className="minus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                             <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"/>
                             <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"/>
                            </svg>
                        </div>
                      </div>
                      <div className="integration-accordion-content">
                       <p>Manage who has permission to create Marketo integration projects in OPAL-Marketing.
                         Users can set up their Marketo credentials in the "Integration" subtab of the My Account page.</p>
                       <div className="table-responsive global-table">
                          <table className="sortable">
                            <thead>
                                <th>Name</th>
                                <th>Role</th>
                                <th>Department</th>
                                <th>Access to Marketo</th>
                            </thead>
                            <tbody>
                                <tr>
                                  <td>App Stage Dev</td>
                                  <td>Administrator</td>
                                  <td>
                                    Anurag V Test Department, BDept, Depart_1
                                  <a href="#" onClick={showModel}> + 16</a>
                                  </td>
                                  <td>
                                    <div className="flex-center gap-10">
                                      <div className="yes-no-customradio">
                                        <input type="radio" className="form-check-input" name="radio1" id="rd1" checked />
                                        <label className="form-check-label" for="rd1">Yes</label>
                                      </div>
                                      <div className="yes-no-customradio">
                                        <input type="radio" className="form-check-input" name="radio1" id="rd2" />
                                        <label className="form-check-label" for="rd2">No</label>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td>Aditya MS</td>
                                  <td>Project Manager</td>
                                  <td>
                                    Anurag V Test Department, BDept, Depart_1
                                  <a href="#"> + 16</a>
                                  </td>
                                  <td>
                                    <div className="flex-center gap-10">
                                      <div className="yes-no-customradio">
                                        <input type="radio" className="form-check-input" name="radio2" id="rd3" />
                                        <label className="form-check-label" for="rd3">Yes</label>
                                      </div>
                                      <div className="yes-no-customradio">
                                        <input type="radio" className="form-check-input" name="radio2" id="rd4" checked />
                                        <label className="form-check-label" for="rd4">No</label>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td>App Stage Dev</td>
                                  <td>Administrator</td>
                                  <td>
                                    Anurag V Test Department, BDept, Depart_1
                                  <a href="#"> + 16</a>
                                  </td>
                                  <td>
                                    <div className="flex-center gap-10">
                                      <div className="yes-no-customradio">
                                        <input type="radio" className="form-check-input" name="radio3" id="rd5" />
                                        <label className="form-check-label" for="rd5">Yes</label>
                                      </div>
                                      <div className="yes-no-customradio">
                                        <input type="radio" className="form-check-input" name="radio3" id="rd6" checked />
                                        <label className="form-check-label" for="rd6">No</label>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                             </tbody>
                          </table>
                        </div>
                        <div className="flex flex-end mar-top30">
                           <button className="blue-btn active">Save</button>
                        </div>
                      </div>
                    </div>
                    <div className="integration-accordion-list open">
                      <div className="accordion-heading flex">
                        <div className="left">
                          <strong>Department Settings</strong>
                        </div>
                        <div className="right">
                           <svg className="plus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                             <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"/>
                             <rect x="12.2773" y="6.5" width="1.44444" height="13" rx="0.722222" fill="#1D4ED8"/>
                             <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"/>
                            </svg>
                            <svg className="minus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                             <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"/>
                             <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"/>
                            </svg>
                        </div>
                      </div>
                      <div className="integration-accordion-content">
                       <div className="table-responsive global-table">
                          <table className="sortable">
                            <thead>
                                <th>Department</th>
                                <th>Default include dependencies checkbox behavior (on/off)</th>
                                <th>Translate tokens in ancestor projects/folders</th>
                                <th>Translate form validation messages</th>
                                <th>Translate Velocity Script Tokens</th>
                                <th>System User Credentials</th>
                            </thead>
                            <tbody>
                                <tr>
                                  <td>Depart_1</td>
                                  <td>
                                    <div className="form-check">
                                      <input className="form-check-input" type="checkbox" name="checkbox" id="chk1" checked />
                                      <label className="form-check-label" aria-label="checkbox" for="chk1">&nbsp;</label>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="form-check">
                                      <input className="form-check-input" type="checkbox" name="checkbox" id="chk2" checked />
                                      <label className="form-check-label" aria-label="checkbox" for="chk2">&nbsp;</label>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="form-check">
                                      <input className="form-check-input" type="checkbox" name="checkbox" id="chk3" checked />
                                      <label className="form-check-label" aria-label="checkbox" for="chk3">&nbsp;</label>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="form-check">
                                      <input className="form-check-input" type="checkbox" name="checkbox" id="chk4" checked />
                                      <label className="form-check-label" aria-label="checkbox" for="chk4">&nbsp;</label>
                                    </div>
                                  </td>
                                  <td>
                                   <div className="flex-center">
                                    <span>bharti.garg@cloudwords.com</span>
                                    <button className="inline-flex ml-10" aria-label="edit">
                                      <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="none">
                                        <path d="M4.65122 14.1491H0.817969V10.3143L10.5199 0.642481L10.52 0.642316C10.8375 0.324878 11.2595 0.15 11.7092 0.15C12.1589 0.15 12.5809 0.324838 12.8993 0.643233L14.3532 2.09707C14.6715 2.41546 14.8464 2.83748 14.8464 3.28717C14.8464 3.73685 14.6715 4.15887 14.3532 4.47727L4.65122 14.1491ZM11.8152 1.7272L11.7093 1.62143L11.6033 1.7271L10.1467 3.1791L10.0403 3.2852L10.1466 3.39143L11.6004 4.84435L11.7063 4.95015L11.8123 4.84452L13.2698 3.39252L13.3764 3.28638L13.27 3.18012L11.8152 1.7272ZM2.3513 12.4657V12.6157H2.5013H3.95605H4.01805L4.06195 12.572L10.5144 6.13973L10.6208 6.03367L10.5145 5.92743L9.0607 4.4736L8.9548 4.3677L8.84873 4.47343L2.3954 10.9066L2.3513 10.9506V11.0128V12.4657ZM0.817969 16.2824H15.1846V17.8157H0.817969V16.2824Z" fill="#1D4ED8" stroke="#F1F5FF" strokeWidth="0.3"/>
                                      </svg>
                                    </button>
                                   </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td>Department1</td>
                                  <td>
                                    <div className="form-check">
                                      <input className="form-check-input" type="checkbox" name="checkbox" id="chk5" checked />
                                      <label className="form-check-label" aria-label="checkbox" for="chk5" >&nbsp;</label>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="form-check">
                                      <input className="form-check-input" type="checkbox" name="checkbox" id="chk6" checked />
                                      <label className="form-check-label" aria-label="checkbox" for="chk6">&nbsp;</label>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="form-check">
                                      <input className="form-check-input" type="checkbox" name="checkbox" id="chk7" checked />
                                      <label className="form-check-label" aria-label="checkbox" for="chk7">&nbsp;</label>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="form-check">
                                      <input className="form-check-input" type="checkbox" name="checkbox" id="chk8" checked />
                                      <label className="form-check-label" aria-label="checkbox" for="chk8">&nbsp;</label>
                                    </div>
                                  </td>
                                  <td>
                                   <div className="flex-center">
                                    <span>bharti.garg@cloudwords.com</span>
                                    <button className="inline-flex ml-10" aria-label="edit">
                                      <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="none">
                                        <path d="M4.65122 14.1491H0.817969V10.3143L10.5199 0.642481L10.52 0.642316C10.8375 0.324878 11.2595 0.15 11.7092 0.15C12.1589 0.15 12.5809 0.324838 12.8993 0.643233L14.3532 2.09707C14.6715 2.41546 14.8464 2.83748 14.8464 3.28717C14.8464 3.73685 14.6715 4.15887 14.3532 4.47727L4.65122 14.1491ZM11.8152 1.7272L11.7093 1.62143L11.6033 1.7271L10.1467 3.1791L10.0403 3.2852L10.1466 3.39143L11.6004 4.84435L11.7063 4.95015L11.8123 4.84452L13.2698 3.39252L13.3764 3.28638L13.27 3.18012L11.8152 1.7272ZM2.3513 12.4657V12.6157H2.5013H3.95605H4.01805L4.06195 12.572L10.5144 6.13973L10.6208 6.03367L10.5145 5.92743L9.0607 4.4736L8.9548 4.3677L8.84873 4.47343L2.3954 10.9066L2.3513 10.9506V11.0128V12.4657ZM0.817969 16.2824H15.1846V17.8157H0.817969V16.2824Z" fill="#1D4ED8" stroke="#F1F5FF" strokeWidth="0.3"/>
                                      </svg>
                                    </button>
                                   </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td>Department2</td>
                                  <td>
                                    <div className="form-check">
                                      <input className="form-check-input" type="checkbox" name="checkbox" id="chk10" checked />
                                      <label className="form-check-label" aria-label="checkbox" for="chk10">&nbsp;</label>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="form-check">
                                      <input className="form-check-input" type="checkbox" name="checkbox" id="chk11" checked />
                                      <label className="form-check-label" aria-label="checkbox" for="chk11">&nbsp;</label>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="form-check">
                                      <input className="form-check-input" type="checkbox" name="checkbox" id="chk12"  />
                                      <label className="form-check-label" aria-label="checkbox" for="chk12">&nbsp;</label>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="form-check">
                                      <input className="form-check-input" type="checkbox" name="checkbox" id="chk13" />
                                      <label className="form-check-label" aria-label="checkbox" for="chk13">&nbsp;</label>
                                    </div>
                                  </td>
                                  <td>
                                   <div className="flex-center">
                                    <span>bharti.garg@cloudwords.com</span>
                                    <button className="inline-flex ml-10" aria-label="edit">
                                      <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="none">
                                        <path d="M4.65122 14.1491H0.817969V10.3143L10.5199 0.642481L10.52 0.642316C10.8375 0.324878 11.2595 0.15 11.7092 0.15C12.1589 0.15 12.5809 0.324838 12.8993 0.643233L14.3532 2.09707C14.6715 2.41546 14.8464 2.83748 14.8464 3.28717C14.8464 3.73685 14.6715 4.15887 14.3532 4.47727L4.65122 14.1491ZM11.8152 1.7272L11.7093 1.62143L11.6033 1.7271L10.1467 3.1791L10.0403 3.2852L10.1466 3.39143L11.6004 4.84435L11.7063 4.95015L11.8123 4.84452L13.2698 3.39252L13.3764 3.28638L13.27 3.18012L11.8152 1.7272ZM2.3513 12.4657V12.6157H2.5013H3.95605H4.01805L4.06195 12.572L10.5144 6.13973L10.6208 6.03367L10.5145 5.92743L9.0607 4.4736L8.9548 4.3677L8.84873 4.47343L2.3954 10.9066L2.3513 10.9506V11.0128V12.4657ZM0.817969 16.2824H15.1846V17.8157H0.817969V16.2824Z" fill="#1D4ED8" stroke="#F1F5FF" strokeWidth="0.3"/>
                                      </svg>
                                    </button>
                                   </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td>Department2</td>
                                  <td>
                                    <div className="form-check">
                                      <input className="form-check-input" type="checkbox" name="checkbox" id="chk14" checked />
                                      <label className="form-check-label" aria-label="checkbox" for="chk14">&nbsp;</label>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="form-check">
                                      <input className="form-check-input" type="checkbox" name="checkbox" id="chk15" checked />
                                      <label className="form-check-label" aria-label="checkbox" for="chk15">&nbsp;</label>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="form-check">
                                      <input className="form-check-input" type="checkbox" name="checkbox" id="chk16"  />
                                      <label className="form-check-label" aria-label="checkbox" for="chk16">&nbsp;</label>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="form-check">
                                      <input className="form-check-input" type="checkbox" name="checkbox" id="chk17" />
                                      <label className="form-check-label" aria-label="checkbox" for="chk17">&nbsp;</label>
                                    </div>
                                  </td>
                                  <td>
                                   <div className="flex-center">
                                     <button className="blue-btn">Setup</button>
                                   </div>
                                  </td>
                                </tr>
                            </tbody>
                          </table>
                        </div>
                        <div className="flex flex-end mar-top30">
                           <button className="blue-btn active">Save</button>
                        </div>
                      </div>
                    </div>
                    <div className="integration-accordion-list open">
                      <div className="accordion-heading flex">
                        <div className="left">
                          <strong>Marketo API Settings</strong>
                        </div>
                        <div className="right">
                           <svg className="plus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                             <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"/>
                             <rect x="12.2773" y="6.5" width="1.44444" height="13" rx="0.722222" fill="#1D4ED8"/>
                             <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"/>
                            </svg>
                            <svg className="minus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                             <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"/>
                             <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"/>
                            </svg>
                        </div>
                      </div>
                      <div className="integration-accordion-content">
                         <p className="f14-para">Enter your Marketo API information here in order to sync financial data back to Marketo.
                           To find this information in Marketo, go to the "Admin" section and click on "SOAP API".
                            You must be have admin privileges on your Marketo account in order to access this info</p>
                            <div className="wrap-input-text-group mar-bot20">
                               <label>SOAP endpoint</label>
                               <div className="input-text-group flex">
                                <input type="text" className="form-control-sm" placeholder="SOAP endpoint" />
                               </div>
                            </div>
                            <div className="wrap-input-text-group mar-bot20">
                               <label>User ID</label>
                               <div className="input-text-group flex">
                                <input type="text" className="form-control-sm" placeholder="User ID" />
                               </div>
                            </div>
                            <div className="wrap-input-text-group mar-bot20">
                               <label>Encryption Key</label>
                               <div className="input-text-group flex">
                                <input type="text" className="form-control-sm" placeholder="Encryption Key" />
                               </div>
                            </div>
                            <div className="flex flex-end mar-top20">
                              <button className="blue-btn active">Save</button>
                            </div>
                      </div>
                    </div>
                  </div> 
                </div>
             </div>
          </div>
        </section>
      </div>
      
         <div className="lightbox-panel target-lang-popup">
            <div className="inner-lightbox-panel pb-0">
            <div className="modal-header flex padd-lr">
              <strong>Departments</strong>
              <button className="close" aria-label="close right popup" onClick={hideModel}>
              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                <path d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z" fill="white"></path>
                <path d="M15.1267 15.1269C14.8925 15.3611 14.5169 15.3611 14.2827 15.1269L10.4998 11.3441L6.71699 15.1269C6.48278 15.3611 6.10715 15.3611 5.87293 15.1269C5.63871 14.8927 5.63871 14.517 5.87293 14.2828L9.65576 10.5L5.87293 6.71716C5.63871 6.48295 5.63871 6.10732 5.87293 5.8731C5.98783 5.7582 6.1425 5.69633 6.29275 5.69633C6.443 5.69633 6.59768 5.75378 6.71257 5.8731L10.4954 9.65593L14.2782 5.8731C14.3931 5.7582 14.5478 5.69633 14.6981 5.69633C14.8527 5.69633 15.003 5.75378 15.1179 5.8731C15.3521 6.10732 15.3521 6.48295 15.1179 6.71716L11.3439 10.5L15.1267 14.2828C15.3609 14.517 15.3609 14.8927 15.1267 15.1269Z" fill="white"></path>
              </svg>
             </button>
             </div>
             <div className="lightbox-content">
               <div className="gb-gray-list">
                  <ul>
                    <li>Anurag V Test Department</li>
                    <li>Anurag V Test Department</li>
                    <li>Marketing-NewDeptt</li>
                    <li>Anurag V Test Department</li>
                    <li>Depart_1</li>
                    <li>Marketing-NewDeptt</li>
                    <li>DDepartment-4</li>
                    <li>Anurag V Test Department</li>
                    <li>Anurag V Test Department</li>
                    <li>Anurag V Test Department</li>
                    <li>Anurag V Test Department</li>
                    <li>Marketing-NewDeptt</li>
                    <li>Anurag V Test Department</li>
                    <li>Depart_1</li>
                    <li>Marketing-NewDeptt</li>
                  </ul>
               </div>
             </div>	
            
            </div>		
          </div>
    </div>
  );
}
